export const PRODUCTION_SITES = Object.freeze({
    TYPES: {
        SHIPPING: 1,
        CUTTING: 2,
        BINDING: 3,
        ORDERS: 4,
        SIGNATURES: 5,
        LABEL_GENERATION: 6,
        OFFSET_PRINTING: 7
    }
})
